// extracted by mini-css-extract-plugin
export var standaloneTable = "_i6-0";
export var standaloneTableWithBodyFill = "_i6-1";
export var withExtraHeader = "_i6-2";